import { ISO_DATE_TIME_REGEX } from 'constants/regex';
import moment from 'moment-timezone';

export const isObject = (v): v is object => v?.constructor === Object;

export const isBoolean = (v): v is boolean => typeof v === 'boolean';

export const isNumber = (v): v is number => typeof v === 'number' && isFinite(v);

export const isBigInt = (v): v is bigint => typeof v === 'bigint';

export const isString = (v): v is string => typeof v === 'string';

export const isSymbol = (v): v is symbol => typeof v === 'symbol';

export const isFunction = (v): v is Function => typeof v === 'function'; // eslint-disable-line

export const isDefined = (v) => typeof v !== 'undefined';

export const hasValue = (v) => isDefined(v) && v !== null;

export const isEmpty = (v) => !hasValue(v) && v !== '';

export const isArray = (v): v is Array<any> => Array.isArray(v);

export const isMoment = (v): v is moment.Moment => moment.isMoment(v);

export const isDate = (v): v is Date => v instanceof Date;

export const isIsoDateString = (v) => ISO_DATE_TIME_REGEX.test(v) && moment(v, moment.ISO_8601, true).isValid();
